<app-loader></app-loader>
<app-header [menuPrincipal]="menuPrincipal!()" />
<main class="box_main">
	<router-outlet></router-outlet>
</main>
<app-metodosdepago />
<app-footer
	[menuRutasFrecuentes1]="menuRutasFrecuentes1!()"
	[menuRutasFrecuentes2]="menuRutasFrecuentes2!()"
	[menuEnlaces]="menuEnlaces!()"
	[menuEnlaces2]="menuEnlaces2!()"
/>
<app-offcanvas-rigth [menuOffcanvasRigthDesktop]="MenuOffcanvasRigth!()" />
@if(isOffcanvasVisible){
<div id="backtrack" class="fixed inset-0 bg-black bg-opacity-50 z-[7]"></div>
}
<app-boton-wsp [verificador]="botonMasArriba()" />
<app-popup-escalas *ngIf="popupVisible" [payload]="popupPayload" (closed)="onPopupClosed()" />

<div [ngClass]="{ 'clase-false': !viewBuscador }">
	<app-buscardorhome-mobile *ngIf="isMobile" [codigoEcommerceVuelta]="codigoSig" />
</div>
